export const STATIC_3A_SUPPORTED_LOCALES = ['en-CH', 'de-CH', 'fr-CH'] as const;

export type Static3aDocsLocale = (typeof STATIC_3A_SUPPORTED_LOCALES)[number];
export type Static3aDocsTitleKeys = 'feeSchedule' | 'generalTermsAndCond' | 'investmentRegulations' | 'rulesOfProcedure' | 'pensionSchemeRegulations';

export interface Static3aDocs {
  titleKey: Static3aDocsTitleKeys;
  link: Record<Static3aDocsLocale, string>;
}

export const static3aDocs: Static3aDocs[] = [
  {
    titleKey: 'feeSchedule',
    link: {
      'en-CH': 'https://liberty.ch/asset/5459c22c-b7b7-4487-acb4-f8a349cf101a/lib3a_reglement_kosten_en.pdf',
      'de-CH': 'https://liberty.ch/asset/6feb9da7-6924-4e0f-a956-93dc4f40ff74/lib3a_reglement_kosten_de.pdf',
      'fr-CH': 'https://liberty.ch/asset/9163e5b1-70bc-4a1f-8d61-399a2019bfa1/lib3a_reglement_kosten_fr.pdf'
    }
  },
  {
    titleKey: 'generalTermsAndCond',
    link: {
      'en-CH': 'https://liberty.ch/asset/1ff24fe0-3009-498c-a38d-703c11830f6d/lib3a_agb_en.pdf',
      'de-CH': 'https://liberty.ch/asset/52105190-fb23-44e1-b3ee-6f713b45e30a/lib3a_agb_de.pdf',
      'fr-CH': 'https://liberty.ch/asset/e8ef20b0-71d9-4de3-b245-8a469dc21b5a/lib3a_agb_fr.pdf'
    }
  },
  {
    titleKey: 'investmentRegulations',
    link: {
      'en-CH': 'https://liberty.ch/asset/df39e3c7-851c-49b2-940b-61863489e168/lib3a_reglement_anlage_en.pdf',
      'de-CH': 'https://liberty.ch/asset/6069f034-f5e4-4667-bed3-735652025dcb/lib3a_reglement_anlage_de.pdf',
      'fr-CH': 'https://liberty.ch/asset/9a0eae0d-5693-4715-83f1-a21921e972b7/lib3a_reglement_anlage_fr.pdf'
    }
  },
  {
    titleKey: 'rulesOfProcedure',
    link: {
      'en-CH': 'https://liberty.ch/asset/f776a660-a544-4094-bd2d-0911752da91b/lib3a_reglement_organisation_en.pdf',
      'de-CH': 'https://liberty.ch/asset/83afc557-5d08-40fd-8a55-531c1b3320b5/lib3a_reglement_organisation_de.pdf',
      'fr-CH': 'https://liberty.ch/asset/54518c72-cd52-490a-9f8b-5f87026f9b54/lib3a_reglement_organisation_fr.pdf'
    }
  },
  {
    titleKey: 'pensionSchemeRegulations',
    link: {
      'en-CH': 'https://liberty.ch/asset/38f2d60b-ff6b-4750-a452-cd12bcdd160f/lib3a_reglement_vorsorge_en.pdf',
      'de-CH': 'https://liberty.ch/asset/21cabcc7-58b7-41f6-bc4a-9b0bb13d6e39/lib3a_reglement_vorsorge_de.pdf',
      'fr-CH': 'https://liberty.ch/asset/9d5fdc7c-4c60-4e12-9a5e-72082e1b4d9f/lib3a_reglement_vorsorge_fr.pdf'
    }
  }
];

export interface StaticDocument {
  id: string;
  type: string;
  attributes: {
    category: string | null;
    title: string;
    account_type: string | null;
    date?: string;
    externalUrl?: string;
  };
}
